import { useState, useEffect } from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
import api from '../../services/api';

export default function VideoRating({ videoId }) {
  const [myRating, setMyRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [average, setAverage] = useState(0);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRatings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoId]);

  const loadRatings = async () => {
    try {
      const [myRatingRes, averageRes] = await Promise.all([
        api.get(`/ratings/video/${videoId}/my-rating`),
        api.get(`/ratings/video/${videoId}/average`)
      ]);

      setMyRating(myRatingRes.data?.rating || 0);
      setAverage(averageRes.data.average);
      setCount(averageRes.data.count);
    } catch (error) {
      console.error('Erro ao carregar avaliações:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRate = async (rating) => {
    try {
      await api.post('/ratings', {
        video_id: videoId,
        rating
      });
      
      setMyRating(rating);
      await loadRatings(); // Recarregar para atualizar média
    } catch (error) {
      console.error('Erro ao avaliar:', error);
      alert('Erro ao salvar avaliação');
    }
  };

  if (loading) {
    return (
      <div className="flex items-center gap-2">
        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-primary-500"></div>
        <span className="text-text-secondary text-sm">Carregando avaliações...</span>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Minha Avaliação */}
      <div>
        <p className="text-sm font-semibold text-text-primary mb-2">
          {myRating > 0 ? 'Sua Avaliação' : 'Avaliar este vídeo'}
        </p>
        <div className="flex items-center gap-1">
          {[1, 2, 3, 4, 5].map((star) => (
            <motion.button
              key={star}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={() => handleRate(star)}
              onMouseEnter={() => setHoverRating(star)}
              onMouseLeave={() => setHoverRating(0)}
              className="focus:outline-none"
            >
              <Star
                size={32}
                className={`transition-colors ${
                  star <= (hoverRating || myRating)
                    ? 'fill-yellow-400 text-yellow-400'
                    : 'text-gray-600'
                }`}
              />
            </motion.button>
          ))}
        </div>
      </div>

      {/* Média de Avaliações */}
      {count > 0 && (
        <div className="flex items-center gap-3 pt-3 border-t border-gray-700">
          <div className="flex items-center gap-1">
            <Star size={20} className="fill-yellow-400 text-yellow-400" />
            <span className="text-xl font-bold text-text-primary">{average.toFixed(1)}</span>
          </div>
          <span className="text-sm text-text-secondary">
            ({count} {count === 1 ? 'avaliação' : 'avaliações'})
          </span>
        </div>
      )}
    </div>
  );
}
